<template>
	<div>
		<HeaderBar title="既往史"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="吸烟史">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq401.bq401003}}</span>
							<span v-show="form.bq401.bq401003=='吸烟'">
								<van-tag plain type="primary" class="followRecord-tag">{{form.bq401.bq401004}}年
								</van-tag>
								<van-tag plain type="primary" class="followRecord-tag">{{form.bq401.bq401005}}支/天
								</van-tag>
							</span>
						</template>
					</van-cell>
				</van-cell-group>

				<van-cell-group title="饮酒史">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq401.bq401006}}</span>
							<span v-show="form.bq401.bq401006=='饮酒'">
								<van-tag plain type="primary" class="followRecord-tag">{{form.bq401.bq401007}}年
								</van-tag>
								<van-tag plain type="primary" class="followRecord-tag">折合酒精平均{{form.bq401.bq401008}}g/天
								</van-tag>
							</span>
						</template>
					</van-cell>
				</van-cell-group>

				<van-cell-group title="输血史">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq401.bq401009}}</span>
							<span v-show="form.bq401.bq401009=='有'">
								<van-tag plain type="primary" class="followRecord-tag">{{form.bq401.bq401010}}年
								</van-tag>
							</span>
						</template>
					</van-cell>
				</van-cell-group>

				<van-cell-group title="高血压">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq401.bq401011}}</span>
						</template>
					</van-cell>
				</van-cell-group>

				<van-cell-group title="糖尿病">
					<van-cell>
						<template #title>
							<span class="followRecord-title">{{form.bq401.bq401012}}</span>
						</template>
					</van-cell>
				</van-cell-group>

				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq401.guid' disabled>
				</FormNormalUpload>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../base/components.js'
	export default {
		name: "page",
		data() {
			return {
				form: {
					bq401: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						extend1: "", //扩展字段
						extend2: "", //扩展字段
						extend3: "", //扩展字段
						extend4: "", //扩展字段
						extend5: "", //扩展字段
						bq001018: "", //患者身份证编号
						bq401003: "不吸烟", //是否吸烟，不吸烟，1-吸烟
						bq401004: "", //吸烟年限
						bq401005: "", //日平均
						bq401006: "不饮酒", //是否饮酒，不饮酒，饮洒
						bq401007: "", //喝酒年限
						bq401008: "", //日平均
						bq401009: "无", //输血史，有，无
						bq401010: "", //输血年份
						bq401011: "无", //高血压，有，无
						bq401012: "无", //糖尿病，有，无
					}
				},
				// 抽烟数组
				bq401003List: [],
				// 饮酒数组
				bq401006List: [],
				// 有/无数组
				existList: [],
				// 年份数组
				yearList: [],
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/S400/bq401/',
				bq400: JSON.parse(sessionStorage.getItem('bq400')) //获取随访信息
			}
		},
		components: {
			...componentsModel,

		},
		props: {
			disabled: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				// this.Back()
			},
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq001018: that.bq400.Bq001_018
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq401/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel,dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq401)
				}, null, null, null);
			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},

		},
		mounted() {
			let that = this
			// 预处理下拉数组
			that.bq401003List = that.$utils.setStandardList(that.$apis.s400Apis.bq401003List)
			that.bq401006List = that.$utils.setStandardList(that.$apis.s400Apis.bq401006List)
			that.existList = that.$utils.setStandardList(that.$apis.s400Apis.existList)
			that.yearList = that.$utils.setStandardList(that.$utils.getYearList(30))

			that.form.bq401.bq001018 = that.bq400.bq001018
			this.LoadInfo()
			this.Resize()
		}
	}
</script>

<style scoped>
	.followRecord-title {
		padding-right: 10px;
	}

	.followRecord-tag {
		margin-right: 10px;
	}
</style>
